import Config from '@/config'
import { colors } from '@/constants/colors'
import { FlowHeader } from '@/ui/core/flow-header'
import { Screen } from '@/ui/core/screen'
import { router } from 'expo-router'
import { WebView } from 'react-native-webview'

/** The sign-up site in a sheet; the page inside is its own, only the chrome around it is ours. */
export default function JoinWallyModal() {
	return (
		<Screen preset="fixed" className="flex flex-1" safeAreaEdges={['top']}>
			<FlowHeader onClose={() => router.back()} />
			<WebView
				style={{ flex: 1, backgroundColor: colors.ground }}
				source={{
					uri: `${Config.JOIN_URL}?utm_source=patient_app`,
				}}
				bounces={false}
			/>
		</Screen>
	)
}
